import type { PropertyIn, PropertyPath } from '@/scopes/common/domain/types'
import {
  PostalCodeCountry,
  RoomWithParticipants,
} from '@/scopes/checkout/domain/types/checkoutPersonalDetails'
import { setIn } from '@/scopes/common/domain/functions/objectDeepOperations'
import { Country } from '@sunwebgroup/ui-components/src/uds'
import { createStore } from 'zustand/vanilla'

export interface ParticipantFormStepState {
  participantsByRooms: RoomWithParticipants[]
  availablePhoneCountries: Country[]
  availablePostalCodeCountries: PostalCodeCountry[]
  isFetched: boolean
  fetchingError: boolean
  isSubmitting: boolean
  submissionError: boolean
  confirmActionWindowIsOpen: boolean
  nextStepUrl: string
}

const defaultInitialState: ParticipantFormStepState = {
  participantsByRooms: [],
  availablePhoneCountries: [],
  availablePostalCodeCountries: [],
  isFetched: false,
  fetchingError: false,
  isSubmitting: false,
  submissionError: false,
  confirmActionWindowIsOpen: false,
  nextStepUrl: '',
}

export interface ParticipantFormStepActions {
  initialize: (state: ParticipantFormStepState) => void
  setIn: <K extends PropertyPath<ParticipantFormStepState>>(
    path: K,
    value: PropertyIn<ParticipantFormStepState, K>
  ) => void
}

export type ParticipantFormStepStore = ParticipantFormStepState & ParticipantFormStepActions

export const participantsFormStepStore = createParticipantsFormStepStore()

export function createParticipantsFormStepStore(initialState: ParticipantFormStepState = defaultInitialState) {
  return createStore<ParticipantFormStepStore>(set => ({
    ...initialState,
    initialize: (state: ParticipantFormStepState) => {
      set(() => state)
    },
    setIn: (path, value) => {
      set(state => setIn(state, path, value))
    },
  }))
}
